var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "contentBox",
    { attrs: { noScrollFix: true } },
    [
      _vm.features && _vm.features.length > 0
        ? _c("contentTitle", {
            attrs: {
              label: _vm.features.length + " FEATURES",
              labelClass: "text-white"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.features && _vm.features.length > 0
        ? _c("contentBody", { attrs: { bg: "rgba(55,71,79,0.6)" } }, [
            _c(
              "div",
              {
                ref: "view",
                staticClass: "w-100 p-2",
                attrs: { id: "feature-list" }
              },
              _vm._l(_vm.features, function(feature, index) {
                return _c(
                  "div",
                  { key: feature.layer.id + "-" + feature.id },
                  [_c("featureRow", { attrs: { feature: feature } })],
                  1
                )
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0128589e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0128589e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/feature/feature-list.vue
// module id = null
// module chunks = 